import React from "react";

const Comment = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.7154 0.546448C24.3055 0.136612 23.7591 0 23.2126 0H2.58423C2.03778 0 1.49133 0.136612 1.0815 0.68306C0.671661 1.0929 0.398438 1.63934 0.398438 2.18579V17.8962C0.398438 18.4426 0.671661 18.9891 1.0815 19.3989C1.49133 19.8087 2.03778 20.082 2.58423 20.082H20.8902L25.3984 24.5902V2.04918C25.3984 1.50273 25.1252 0.956284 24.7154 0.546448ZM20.2072 14.9024C20.2072 15.0128 20.1176 15.1024 20.0072 15.1024H5.78969C5.67924 15.1024 5.58969 15.0128 5.58969 14.9024V13.3148C5.58969 13.2043 5.67924 13.1148 5.78969 13.1148H20.0072C20.1176 13.1148 20.2072 13.2043 20.2072 13.3148V14.9024ZM20.2072 10.8831C20.2072 10.9935 20.1176 11.0831 20.0072 11.0831H5.78969C5.67924 11.0831 5.58969 10.9935 5.58969 10.8831V9.353C5.58969 9.24255 5.67924 9.153 5.78969 9.153H20.0072C20.1176 9.153 20.2072 9.24255 20.2072 9.353V10.8831ZM20.2072 6.91434C20.2072 7.0248 20.1176 7.11434 20.0072 7.11434H5.78969C5.67924 7.11434 5.58969 7.0248 5.58969 6.91434V5.39126C5.58969 5.2808 5.67924 5.19126 5.78969 5.19126H20.0072C20.1176 5.19126 20.2072 5.2808 20.2072 5.39126V6.91434Z"
      fill={color}
    />
  </svg>
);

Comment.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Comment;
